
import { IHocKyDangKy } from "../../../model/respone/lop-tin-chi/IHocKyDangKy";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eHocKyDangKyActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IHocKyDangKy[],
  LOAD_ERRR: "",


  SHOW_EDIT_MODAL: {} as IHocKyDangKy | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IHocKyDangKy,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",

};
export const eHocKyDangKyActionIds = generateActionTypeIds(
  eHocKyDangKyActionsObj,
  "HOC_KY_DANG_KY"
);
export type IHocKyDangKyActionTypes = IGenericActionType<
  typeof eHocKyDangKyActionsObj,
  "HOC_KY_DANG_KY"
>;
